import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LogIn, Gift, Sparkles } from 'lucide-react';
import Popup from '../components/Popup';
import { apiUrl } from '../utils/apiUrl';
import './Entrance.css';

function Entrance() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showAirdrop, setShowAirdrop] = useState(false);
  const [voucherClaimed, setVoucherClaimed] = useState(false);
  const [popup, setPopup] = useState({ isOpen: false, title: '', message: '' });

  useEffect(() => {
    // Demo feature: Reset state on mount so user can experience the flow every time
    setIsLoggedIn(false);
    setVoucherClaimed(false);
    setShowAirdrop(false);
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
    setTimeout(() => {
      setShowAirdrop(true);
    }, 600);
  };

  const handleClaimVoucher = async () => {
    try {
      const response = await fetch(apiUrl('/api/durian/airdrop'), { method: 'POST' });
      const data = await response.json();
      if (data.status === 'Success') {
        localStorage.setItem('durian_voucher_claimed', 'true');
        localStorage.setItem('durian_voucher_available', 'true');
        setVoucherClaimed(true);
        setShowAirdrop(false);
        setPopup({ isOpen: true, title: 'Awesome!', message: 'Welcome Gift Voucher added to your wallet!' });
      }
    } catch (error) {
      localStorage.setItem('durian_voucher_claimed', 'true');
      localStorage.setItem('durian_voucher_available', 'true');
      setVoucherClaimed(true);
      setShowAirdrop(false);
      setPopup({ isOpen: true, title: 'Awesome!', message: 'Welcome Gift Voucher added to your wallet!' });
    }
  };

  return (
    <div className="page-container entrance-page">
      <div className="entrance-bg-elements">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>

      <div className="content-wrapper">
        <motion.div 
          className="hero-section"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="badge">1st-of-its Kind Premium Experience</div>
          <h1 className="title">Where Durian Meets<br/>The Future</h1>
          <p className="subtitle">A phygital orchard journey blending nature, culture, rewards & immersive experiences - all in one destination.</p>
        </motion.div>

        {!isLoggedIn ? (
          <motion.div 
            className="login-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
          >
            <div className="icon-wrapper">
              <Sparkles size={32} color="var(--durian-gold)" />
            </div>
            <h2>Unlock Your Orchard Pass</h2>
            <p>Sign up & connect your VIO wallet to unlock curated experiences & exclusive gifts</p>
            <button className="btn-primary login-btn" onClick={handleLogin}>
              <LogIn size={20} />
              Activate Experience
            </button>
          </motion.div>
        ) : (
          <motion.div 
            className="welcome-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
          >
            <h2>Welcome back, Explorer!</h2>
            <p>Your wallet is connected. You are ready to explore the orchard trails.</p>
            {voucherClaimed && (
              <div className="voucher-status">
                <Gift size={20} color="var(--durian-green-dark)" />
                <span>Welcome Voucher Claimed</span>
              </div>
            )}
          </motion.div>
        )}
      </div>

      <AnimatePresence>
        {showAirdrop && (
          <motion.div 
            className="airdrop-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div 
              className="airdrop-content"
              initial={{ y: -500, rotate: -180, scale: 0.5 }}
              animate={{ y: 0, rotate: 0, scale: 1 }}
              transition={{ type: "spring", bounce: 0.6, duration: 1.5 }}
            >
              <div className="glow-effect"></div>
              <img src="/cendol.png" alt="Cendol" className="durian-icon-img" style={{ objectFit: 'contain' }} />
              <h2>Surprise Airdrop!</h2>
              <p>You received a Free Durian Cendol Voucher</p>
              <button className="btn-primary claim-btn" onClick={handleClaimVoucher}>
                Claim My Welcome Gift
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <Popup 
        isOpen={popup.isOpen} 
        onClose={() => setPopup({ ...popup, isOpen: false })} 
        title={popup.title} 
        message={popup.message} 
      />
    </div>
  );
}

export default Entrance;
